import {
  toggleModalConfirm,
  toggleModal,
  setCurrentStep,
} from "@/store/slices/GlobalSlice";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

const ButtonModalClose = (props) => {
  const { isFinalStep, currentModal, isUploadedImage } = useSelector(
    (state) => state.globalSlice
  );
  const dispatch = useDispatch();

  const handleClose = () => {
    // show prize modal
    if (currentModal === "prize" || currentModal === "townSlider") {
      dispatch(toggleModal());
      return;
    }

    // show confirm modal
    if (isUploadedImage && !isFinalStep) {
      dispatch(toggleModalConfirm());
      return;
    }

    // close form modal
    dispatch(toggleModal());

    if (isFinalStep) {
      dispatch(setCurrentStep(""));
    }
  };

  return (
    <div
      className="bg-sgbc-green-500 rounded-full w-50 h-50 flex items-center justify-center"
      onClick={handleClose}
    >
      <img src={require("@/assets/images/closeIcon.png")} alt="icon" />
    </div>
  );
};

ButtonModalClose.propTypes = {};

export default ButtonModalClose;
